import React from 'react';
import './Copies.scss';
import drKKoo from '../../assets/drKoo.jpg';
// import { AnimatePresence, motion } from 'framer-motion/dist/framer-motion';

function Copy6() {
  return (
    <section className="copies marginTopAdd">
      <h4 className="copies__title title">Managing All Aspects of the Condition</h4>
      <div className="inlinePhoto inlinePhoto--desktop--left">
        <img className="inlinePhoto__image" src={drKKoo} alt="Portrait of Dr. Zakiya Rice" />
        {/* <p className="inlinePhoto__name inlinePhoto--description">Dr. Zakiya Rice</p> */}
        <p className="inlinePhoto__title inlinePhoto--description">
          Dr. John Koo, Psychodermatologist & Professor
        </p>
      </div>
      <p className="copies__copy">
        The emotional anguish of dealing with eczema can be difficult to bear, but there are paths
        to healing both physically and emotionally.
      </p>
      <p className="copies__copy">
        The first step is to get physical symptoms under control, stresses Dr. Koo. From both a
        medical and psychiatric standpoint, he says that addressing the root cause of the emotional
        distress—the eczema itself—is a good starting point.
      </p>

      <p className="copies__copy">
        Boey points out that paying attention to triggers such as clothing has been key to managing
        his flare-ups. Sweat, wool, and rough fabrics are triggers for him, but others with the
        condition may have different ones. He tries to stick to light cotton clothing and finds that
        air conditioning helps, especially in the hot climate of his home country, Singapore.
      </p>
      <p className="copies__copy">
        Mack stresses that you shouldn’t be afraid to self-advocate. “Not all treatments work for
        all people, do not be afraid to tell your doctor that something isn't cutting it.”
      </p>
    </section>
  );
}

export default Copy6;
